:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._cur-pointer{cursor:pointer;}
:root ._width-10037{width:100%;}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-column{flex-direction:column;}
:root ._grow-1{flex-grow:1;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._ff-f-family{font-family:var(--f-family);}
:root ._dsp-inline{display:inline;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-color{color:var(--color);}
:root ._items-center{align-items:center;}
:root ._o-0--5{opacity:0.5;}
:root ._justify-center{justify-content:center;}